import type { MazeCell, RouteMaze } from './mazeGenerator';

export type RouteDirection = 'up' | 'down' | 'left' | 'right';

export const ROUTE_DIRECTION_VECTORS: Record<RouteDirection, MazeCell> = {
  up: { x: 0, y: -1 },
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
  right: { x: 1, y: 0 },
};

export function oppositeDirection(direction: RouteDirection): RouteDirection {
  return ({ up: 'down', down: 'up', left: 'right', right: 'left' } as const)[direction];
}

export function isRouteOpen(maze: RouteMaze, cell: MazeCell, direction: RouteDirection): boolean {
  const vector = ROUTE_DIRECTION_VECTORS[direction];
  return maze.tiles[cell.y + vector.y]?.[cell.x + vector.x] === 0;
}

/**
 * Sürekli yürüyüşte istenen dönüş kavşakta mümkünse önce onu alır; değilse
 * karakter mevcut rotasında devam eder. Önüne duvar gelirse durur.
 */
export function nextContinuousDirection(
  maze: RouteMaze,
  cell: MazeCell,
  current: RouteDirection | null,
  requested: RouteDirection | null,
): RouteDirection | null {
  if (requested && isRouteOpen(maze, cell, requested)) return requested;
  if (current && isRouteOpen(maze, cell, current)) return current;
  return null;
}
